import { render, staticRenderFns } from "./companies-add-or-update.vue?vue&type=template&id=75e6982e&scoped=true&"
import script from "./companies-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companies-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./companies-add-or-update.vue?vue&type=style&index=0&id=75e6982e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e6982e",
  null
  
)

export default component.exports